import React, { forwardRef, useCallback } from 'react';

import { Checkbox, FormControlLabel, type SxProps, type Theme } from '@mui/material';

import {
  CheckboxButtonIcon,
  CheckboxCheckedIcon,
} from '@shared/ui-kit/controls/MuiCheckbox/MuiCheckbox.style';

import type { CheckboxProps } from '@mui/material';

type CheckboxSize = 'small' | 'medium';
type MuiCheckboxProps = {
  isDisabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: boolean;
  label?: string;
  isError?: boolean;
  size?: CheckboxSize;
  sx?: SxProps<Theme>;
  checkboxLabelId?: string;
} & Partial<Omit<CheckboxProps, 'onChange'>>;

export const MuiCheckbox = forwardRef<HTMLHeadingElement, MuiCheckboxProps>((props, ref) => {
  const {
    checkboxLabelId,
    isDisabled,
    onChange,
    value,
    label,
    sx,
    isError = false,
    size = 'medium',
    ...args
  } = props;
  const onClickOpenInfoModal = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      if (onChange) {
        onChange(e);
      }
    },
    [onChange],
  );
  return (
    <FormControlLabel
      sx={{ ...sx }}
      id={checkboxLabelId || ''}
      ref={ref}
      control={
        <Checkbox
          {...args}
          disabled={isDisabled}
          checked={value}
          checkedIcon={<CheckboxCheckedIcon isError={isError} size={size} />}
          icon={<CheckboxButtonIcon isError={isError} size={size} />}
          onChange={onClickOpenInfoModal}
          indeterminate={!value && isDisabled}
        />
      }
      label={label}
    />
  );
});
